const CLOUD_NAME = 'hammonds-furniture';
const DEFAULT_OPTIONS = {
    audio: null,
    format: 'mp4',
    width: null,
};
export function videoUrl(id, options = {}) {
    const combined = { ...DEFAULT_OPTIONS, ...options };
    let transformations = '';
    if (options.audio) {
        transformations += '/ac_none';
    }
    if (options.width) {
        transformations += `/w_${options.width}`;
    }
    return `https://res.cloudinary.com/${CLOUD_NAME}/video/upload${transformations}/${id}.${combined.format}`;
}
